/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { PagedResults } from "app/models/paged-results";
import { UserMmcInfo } from "app/models/mmc/user-mmc-info";
import { MmcService } from "app/services/mmc.service";

export const DefaultPageSize = 10;
export const PageSizeProperty = "userMmcsPerPage";

@Injectable()
export class UserMmcInfoResolver implements Resolve<PagedResults<UserMmcInfo>> {

    constructor(
        private mmcService: MmcService
    ) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<UserMmcInfo>> {
      let pageSize: number = route.data[PageSizeProperty];
      if (pageSize == null || pageSize < 1) {
        pageSize = DefaultPageSize;
      }

      try {
        return await this.mmcService.getUsersMmcInfo(0, pageSize);  // Always return the first page (0)
      } catch (error) {
        console.error("Problem resolving User MMC Info!", error);
      }
    }

}
